// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"index_wrapper__9ENnX","list__item":"index_list__item__JG5eZ"};